module.exports = __webpack_public_path__ + "img/list_icon.8810ad50.jpg";